import React, { useState, useEffect } from 'react'
import { Typography, Paper, Avatar, Button } from '@material-ui/core'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import withStyles from '@material-ui/core/styles/withStyles'
import { Link, withRouter } from 'react-router-dom'
import firebase from '../firebase'
import { useTranslation } from 'react-i18next'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import { toast } from 'react-toastify';

const styles = theme => ({
    main: {
        height: '100vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        [theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
            backgroundPosition: 'center center',
        },
    },
    content: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        [theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
            alignItems: 'flex-end',
            justifyContent: 'center',
        },
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        width: '94%',
        margin: 'auto',
        alignItems: 'center',
        zIndex: 99999,
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
        [theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
            width: 400,
        },
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    submit: {
        padding: 12,
        marginTop: theme.spacing(3)
    },
})

function ForgotPassword(props) {
    const { classes } = props
    const { t } = useTranslation()
    const [email, setEmail] = useState('')

    useEffect(() => {
		document.title = window.localStorage.getItem('apptitle') + ` - ${t('forgotpassword.label')}`
	}, [t])

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
			window.location.href = '/dashboard'
            return
        }
    }, [])

    return (
        <main className={classes.main} style={{ backgroundImage: `url(${localStorage.getItem('background')})` }}>
            <div className={classes.content}>
                <Paper className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        {t('forgotpassword.label')}?
				</Typography>
                    <br />
                    <Typography variant="body1" gutterBottom>
                        {t('sendresetpassword.label')}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        <strong>{t('securityresetpassword.label')}</strong>
                    </Typography>
                    <ValidatorForm
                        className={classes.form}
                        onSubmit={forgotPassword}
                    >
                        <TextValidator
                            margin="normal"
                            fullWidth
                            label={t('emailadress.label')}
                            onChange={e => setEmail(e.target.value)}
                            name="email"
                            autoComplete="off"
                            autoFocus
                            inputProps={{
								style: {
									textTransform: 'lowercase'
								}
							}}
                            validators={['required', 'isEmail']}
                            errorMessages={[t('fieldrequired.label'), t('emailnotvalid.label')]}
                            value={email}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}>
                            {t('send.label')}
                        </Button>
                    </ValidatorForm>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="secondary"
                        component={Link}
                        to="/"
                        className={classes.submit}>
                        {t('backhomepage.label')}
                    </Button>
                </Paper>
            </div>
        </main>
    )

    async function wait(ms) {
        return new Promise(resolve => {
            setTimeout(resolve, ms);
        });
    }

    async function forgotPassword() {
        try {
            await firebase.forgotPassword(email)
            await toast.success(t('resetpasswordsent.label'))
            await wait(1500)
            props.history.push('/login')
        } catch (error) {
            alert(error.message)
        }
    }
}

export default withRouter(withStyles(styles)(ForgotPassword))